const SUPPORT_EMAIL = 'support@geekfun.club'

export const SUPPORT_SUBJECT = 'Geekfun support'
export const BILLING_SUPPORT_SUBJECT = 'Geekfun support — Billing'

const BILLING_SUPPORT_CODES = [5011, 5013, 5016] as const

export type SupportMailInput = {
  subject: string
  accountEmail?: string
  product?: string
}

export const supportMailto = ({
  subject,
  accountEmail,
  product = 'Console',
}: SupportMailInput): string => {
  const body = [
    accountEmail ? `Account: ${accountEmail}` : 'Account:',
    `Product: ${product}`,
    '',
    'Expected:',
    '',
    'What happened:',
    '',
  ].join('\n')

  return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

export const isBillingSupportCode = (error: unknown): boolean => {
  if (!error || typeof error !== 'object' || !('code' in error)) return false
  const code = (error as { code: unknown }).code
  return typeof code === 'number' && (BILLING_SUPPORT_CODES as readonly number[]).includes(code)
}
